import { render, staticRenderFns } from "./activityUniversityEvents.html?vue&type=template&id=0a1e143b&scoped=true&external"
import script from "./activityUniversityEvents.vue?vue&type=script&lang=js"
export * from "./activityUniversityEvents.vue?vue&type=script&lang=js"
import style0 from "./activityUniversityEvents.css?vue&type=style&index=0&id=0a1e143b&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a1e143b",
  null
  
)

export default component.exports